import { render, staticRenderFns } from "./url_details.vue?vue&type=template&id=10f73dc4&"
import script from "./url_details.vue?vue&type=script&lang=js&"
export * from "./url_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports